module.exports = __webpack_public_path__ + "img/UI_common_framelabelDX_01_85446da1b.png";